import React from 'react';
import styles from './index.module.scss';

export default function Footer() {
  return (
    <p className={styles.footer}>
      <span className={styles.logo}>EZCON</span>
      <br />
      <span className={styles.copyright}>© 2021.EZCON Technology All rights reserved.</span>
    </p>
  );
}
